import React from "react";
import { Bar, Chip } from "./ChipToggleBar.styles";
import type { ChipToggleBarProps } from "./ChipToggleBar.types";

/** Equal-width pill buttons, one active (`aria-pressed`). */
export const ChipToggleBar: React.FC<ChipToggleBarProps> = ({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}) => (
  <Bar role="group" aria-label={ariaLabel} className={className}>
    {options.map((option) => (
      <Chip
        key={option.id}
        type="button"
        aria-label={option.ariaLabel}
        aria-pressed={option.id === value}
        $active={option.id === value}
        $accent={option.accentColor}
        onClick={() => onChange(option.id)}
      >
        {option.label}
      </Chip>
    ))}
  </Bar>
);

export default ChipToggleBar;
